module.exports = __webpack_public_path__ + "static/media/Knockdown_1920x1080.c8b81279.png";